import type { ElementType } from 'react';

import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';
import { cn } from '@eliadmin/core/src/utils/style-utils';

type RichTextProps = {
  /** HTML from the administration (textbox or editor). */
  html: string;
  /** Typography class from `typography.css`, e.g. `svt-body-l`. */
  variant: string;
  as?: ElementType;
  /** `dark` = on a dark/green surface: emphasis white, links light green. */
  tone?: 'light' | 'dark';
  className?: string;
};

/** Admin text — never rendered as `{value}`, the fields carry HTML. */
export function RichText({ html, variant, as = 'div', tone = 'light', className }: RichTextProps) {
  if (!html) return null;

  return (
    <HtmlRendererRaw
      as={as}
      html={html}
      className={cn('svt-rich', tone === 'dark' && 'svt-rich--dark', variant, className)}
    />
  );
}
